import t from "./index60.mjs";
import f from "./index62.mjs";
function i(o) {
  var r = f(o, "string");
  return t(r) == "symbol" ? r : r + "";
}
export {
  i as default
};
